import React, { useState, useEffect } from "react";

function toInputDate(value) {
  if (!value) return "";
  return new Date(value).toISOString().slice(0, 10);
}

// Input date toujours visible, comme dans la maquette (pc-date-input).
// La valeur est locale pendant l'edition et n'est envoyee qu'au blur,
// pour ne pas declencher une requete a chaque frappe partielle.
function EcheanceCell({ dueDate, canEdit, overdue, onChange }) {
  const [value, setValue] = useState(toInputDate(dueDate));

  useEffect(() => {
    setValue(toInputDate(dueDate));
  }, [dueDate]);

  const commit = () => {
    if (value !== toInputDate(dueDate)) onChange(value || null);
  };

  return (
    <input
      type="date"
      className={`pc-date-input ${overdue ? "is-late" : ""}`}
      value={value}
      disabled={!canEdit}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
    />
  );
}

export default EcheanceCell;
